// extracted by mini-css-extract-plugin
module.exports = {"worldBorderColor":"#ebeef5"};